import { BaseAlert, BaseModalAlert } from "./BaseAlert";

const errorAlert = (message: string) => (
    <BaseAlert title="Error!" message={message} />
);

const errorModal = (message: string) => (
    <BaseModalAlert title="Error!" message={message} />
);

const infoAlert = (message: string) => (
    <BaseAlert title="" message={message} mainColor="#2196F3" notClose />
);

const successAlert = (message: string) => {
    <BaseAlert title="Exito!" message={message} mainColor="#04AA6D" autoClose />;
};

const successModalAlert = (message: string) => {
    <BaseAlert title="Exito!" message={message} mainColor="#04AA6D" autoClose />;
};

export {
    BaseAlert,
    successAlert,
    successModalAlert,
    errorAlert,
    errorModal,
    infoAlert,
};
